module.exports = __webpack_public_path__ + "img/lr_17.27746932.png";